// import React, { useState, useEffect } from 'react';
// import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
// import { Eye, EyeOff } from 'lucide-react';

// const LoginPage = ({ onLoginSuccess, poolData }) => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [showNewPasswordForm, setShowNewPasswordForm] = useState(false);
//   const [cognitoUser, setCognitoUser] = useState(null);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);

//   useEffect(() => {
//     const savedUsername = localStorage.getItem('rememberedUsername');
//     if (savedUsername) {
//       setUsername(savedUsername);
//       setRememberMe(true);
//     }
//   }, []);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     if (rememberMe) {
//       localStorage.setItem('rememberedUsername', username);
//     } else {
//       localStorage.removeItem('rememberedUsername');
//     }

//     try {
//       const authData = { Username: username, Password: password };
//       const userData = { Username: username, Pool: new CognitoUserPool(poolData) };
//       const authDetails = new AuthenticationDetails(authData);
//       const newCognitoUser = new CognitoUser(userData);
//       setCognitoUser(newCognitoUser);

//       newCognitoUser.authenticateUser(authDetails, {
//         onSuccess: (result) => {
//           console.log('Login successful:', result);
//           setLoading(false);
//           onLoginSuccess(username);
//         },
//         onFailure: (err) => {
//           console.error('Auth Error:', err);
//           setError(err.message || 'Login failed');
//           setLoading(false);
//         },
//         newPasswordRequired: (userAttributes, requiredAttributes) => {
//           console.log('New password required');
//           setShowNewPasswordForm(true);
//           setLoading(false);
//         }
//       });
//     } catch (err) {
//       setError(err.message);
//       setLoading(false);
//     }
//   };

//   const handleNewPasswordSubmit = (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     cognitoUser.completeNewPasswordChallenge(newPassword, {}, {
//       onSuccess: (result) => {
//         console.log('Password change successful:', result);
//         setLoading(false);
//         setShowNewPasswordForm(false);
//         onLoginSuccess(username);
//       },
//       onFailure: (err) => {
//         console.error('Password change error:', err);
//         setError(err.message || 'Failed to set new password');
//         setLoading(false);
//       }
//     });
//   };

//   if (showNewPasswordForm) {
//     return (
//       <div className="min-h-screen bg-white flex items-center justify-center p-4">
//         <div className="w-full max-w-md">
//           <div className="bg-white rounded-xl p-8 shadow-lg">
//             <div className="text-center mb-8">
//               <h2 className="text-2xl font-bold text-gray-800">Set New Password</h2>
//               <p className="mt-2 text-gray-600">Please set a new password for your account</p>
//             </div>

//             <form onSubmit={handleNewPasswordSubmit} className="space-y-5">
//               <div className="relative">
//                 <label className="block text-sm font-medium text-gray-700 mb-2">New Password</label>
//                 <input
//                   type={showNewPassword ? "text" : "password"}
//                   value={newPassword}
//                   onChange={(e) => setNewPassword(e.target.value)}
//                   className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
//                   placeholder="Enter your new password"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowNewPassword(!showNewPassword)}
//                   className="absolute right-3 top-9 text-gray-400 hover:text-gray-600"
//                 >
//                   {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                 </button>
//               </div>

//               {error && (
//                 <div className="p-3 bg-red-50 border border-red-100 rounded-lg">
//                   <p className="text-sm text-red-600">{error}</p>
//                 </div>
//               )}

//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="w-full py-3 bg-gradient-to-r from-indigo-600 to-cyan-600 hover:from-indigo-700 hover:to-cyan-700 rounded-lg text-white font-medium shadow-lg shadow-indigo-500/25 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all"
//               >
//                 {loading ? (
//                   <div className="flex items-center justify-center space-x-2">
//                     <div className="w-5 h-5 border-t-2 border-b-2 border-white rounded-full animate-spin"></div>
//                     <span>Setting new password...</span>
//                   </div>
//                 ) : (
//                   'Set New Password'
//                 )}
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-white flex items-center justify-center p-4">
//       <div className="w-full max-w-md">
//         <div className="bg-white rounded-xl p-8 shadow-lg">
//           <div className="text-center mb-8">
//             <div className="flex justify-center mb-4">
//               <img 
//                 src="/logostart.png" 
//                 alt="Nommas Logo" 
//                 className="w-32 h-32 object-contain"
//               />
//             </div>
//             <h2 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-cyan-600 bg-clip-text text-transparent">
// VisionIQ            </h2>
//           </div>

//           <form onSubmit={handleLogin} className="space-y-5">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Licence ID</label>
//               <input
//                 type="text"
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//                 className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
//                 placeholder="Enter your Licence ID"
//               />
//             </div>

//             <div className="relative">
//               <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
//               <input
//                 type={showPassword ? "text" : "password"}
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
//                 placeholder="Enter your password"
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowPassword(!showPassword)}
//                 className="absolute right-3 top-9 text-gray-400 hover:text-gray-600"
//               >
//                 {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//               </button>
//             </div>

//             {error && (
//               <div className="p-3 bg-red-50 border border-red-100 rounded-lg">
//                 <p className="text-sm text-red-600">{error}</p>
//               </div>
//             )}

//             <div className="flex items-center justify-between">
//               <div className="flex items-center">
//                 <input
//                   type="checkbox"
//                   checked={rememberMe}
//                   onChange={(e) => setRememberMe(e.target.checked)}
//                   className="w-4 h-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
//                 />
//                 <label className="ml-2 text-sm text-gray-600">Remember me</label>
//               </div>
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full py-3 bg-gradient-to-r from-indigo-600 to-cyan-600 hover:from-indigo-700 hover:to-cyan-700 rounded-lg text-white font-medium shadow-lg shadow-indigo-500/25 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all"
//             >
//               {loading ? (
//                 <div className="flex items-center justify-center space-x-2">
//                   <div className="w-5 h-5 border-t-2 border-b-2 border-white rounded-full animate-spin"></div>
//                   <span>Signing in...</span>
//                 </div>
//               ) : (
//                 'Sign In'
//               )}
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;
import React, { useState, useEffect } from 'react';
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { Eye, EyeOff } from 'lucide-react';

// Custom animations for modern text transitions
const animationStyles = `
  @keyframes sweep {
    0% { transform: translateX(-100%) skewX(-12deg); }
    100% { transform: translateX(300%) skewX(-12deg); }
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0px) translateX(0px); opacity: 0.7; }
    25% { transform: translateY(-10px) translateX(5px); opacity: 1; }
    50% { transform: translateY(-5px) translateX(-3px); opacity: 0.8; }
    75% { transform: translateY(-8px) translateX(2px); opacity: 0.9; }
  }
  
  @keyframes float-delayed {
    0%, 100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
    25% { transform: translateY(-8px) translateX(-4px); opacity: 0.9; }
    50% { transform: translateY(-12px) translateX(6px); opacity: 1; }
    75% { transform: translateY(-6px) translateX(-2px); opacity: 0.8; }
  }
  
  @keyframes float-slow {
    0%, 100% { transform: translateY(0px) translateX(0px); opacity: 0.5; }
    25% { transform: translateY(-6px) translateX(3px); opacity: 0.8; }
    50% { transform: translateY(-10px) translateX(-5px); opacity: 1; }
    75% { transform: translateY(-4px) translateX(4px); opacity: 0.7; }
  }
  
  @keyframes slideInRight {
    0% { opacity: 0; transform: translateX(50px); }
    100% { opacity: 1; transform: translateX(0); }
  }
  
  @keyframes slideOutLeft {
    0% { opacity: 1; transform: translateX(0); }
    100% { opacity: 0; transform: translateX(-50px); }
  }
  
  @keyframes fadeInUp {
    0% { opacity: 0; transform: translateY(20px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes fadeOutDown {
    0% { opacity: 1; transform: translateY(0); }
    100% { opacity: 0; transform: translateY(-20px); }
  }
  
  @keyframes textGlow {
    0%, 100% { text-shadow: 0 0 10px rgba(59, 130, 246, 0.3); }
    50% { text-shadow: 0 0 20px rgba(59, 130, 246, 0.6), 0 0 30px rgba(6, 182, 212, 0.4); }
  }
  
  .animate-sweep { animation: sweep 3s ease-in-out infinite; }
  .animate-float { animation: float 4s ease-in-out infinite; }
  .animate-float-delayed { animation: float-delayed 5s ease-in-out infinite; animation-delay: 1s; }
  .animate-float-slow { animation: float-slow 6s ease-in-out infinite; animation-delay: 2s; }
  .animate-slide-in-right { animation: slideInRight 0.6s ease-out; }
  .animate-slide-out-left { animation: slideOutLeft 0.4s ease-in; }
  .animate-fade-in-up { animation: fadeInUp 0.8s ease-out; }
  .animate-fade-out-down { animation: fadeOutDown 0.4s ease-in; }
  .animate-text-glow { animation: textGlow 3s ease-in-out infinite; }
`;

// VisionIQ Avatar Logo Component with logo192.png and light animations
const VisionIQLogo = ({ size = 128 }) => (
  <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
    {/* Main logo image */}
    <div className="relative z-10">
      <img 
        src="/logo192.png" 
        alt="VisionIQ Logo" 
        className="rounded-full shadow-lg"
        style={{ width: size, height: size }}
      />
    </div>
    
    {/* Animated light effects overlay */}
    <div className="absolute inset-0 pointer-events-none">
      {/* Rotating light ring */}
      <div className="absolute inset-0 rounded-full animate-spin" style={{ animation: 'spin 8s linear infinite' }}>
        <div className="absolute top-0 left-1/2 w-2 h-2 bg-blue-400 rounded-full transform -translate-x-1/2 -translate-y-1 shadow-lg shadow-blue-400/50">
          <div className="absolute inset-0 bg-blue-400 rounded-full animate-ping"></div>
        </div>
        <div className="absolute bottom-0 right-1/4 w-1.5 h-1.5 bg-cyan-400 rounded-full shadow-lg shadow-cyan-400/50">
          <div className="absolute inset-0 bg-cyan-400 rounded-full animate-ping" style={{ animationDelay: '0.5s' }}></div>
        </div>
        <div className="absolute left-0 top-1/3 w-1 h-1 bg-purple-400 rounded-full shadow-lg shadow-purple-400/50">
          <div className="absolute inset-0 bg-purple-400 rounded-full animate-ping" style={{ animationDelay: '1s' }}></div>
        </div>
      </div>
      
      {/* Pulsing glow effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-500/30 to-cyan-500/30 rounded-full blur-xl animate-pulse"></div>
      
      {/* Light sweep effect */}
      <div className="absolute inset-0 rounded-full overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 translate-x-full animate-sweep"></div>
      </div>
      
      {/* Floating light particles */}
      <div className="absolute top-1/4 left-1/4 w-1 h-1 bg-blue-300 rounded-full animate-float">
        <div className="absolute inset-0 bg-blue-300 rounded-full blur-sm"></div>
      </div>
      <div className="absolute top-3/4 right-1/3 w-0.5 h-0.5 bg-cyan-300 rounded-full animate-float-delayed">
        <div className="absolute inset-0 bg-cyan-300 rounded-full blur-sm"></div>
      </div>
      <div className="absolute bottom-1/4 left-2/3 w-0.5 h-0.5 bg-purple-300 rounded-full animate-float-slow">
        <div className="absolute inset-0 bg-purple-300 rounded-full blur-sm"></div>
      </div>
    </div>
    
    {/* Outer glow ring */}
    <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-cyan-500/10 rounded-full blur-2xl animate-pulse" style={{ transform: 'scale(1.2)' }}></div>
  </div>
);

// Modern Text Animation Component with fast transitions
const ChangingText = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  
  const phrases = [
    "AI-Powered Quality Inspection",
    "Real-Time Defect Detection", 
    "Smart Vision Quality Control",
    "Automated Inspection Systems",
    "Edge AI Quality Analytics",
    "Intelligent Defect Classification",
    "Vision-Based Quality Assurance",
    "Smart Quality Intelligence"
];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % phrases.length);
        setIsTransitioning(false);
      }, 200);
      
    }, 800);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="h-10 flex items-center justify-center">
      <h2 
        className={`text-lg font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent text-center animate-text-glow transition-all duration-200 ease-out ${
          isTransitioning ? 'animate-fade-out-down' : 'animate-fade-in-up'
        }`}
        style={{
          minHeight: '2rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          whiteSpace: 'nowrap'
        }}
      >
        {phrases[currentIndex]}
      </h2>
    </div>
  );
};

const LoginPage = ({ onLoginSuccess, poolData }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showNewPasswordForm, setShowNewPasswordForm] = useState(false);
  const [cognitoUser, setCognitoUser] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  // Load remembered credentials on component mount
  useEffect(() => {
    const rememberedUsername = localStorage.getItem('rememberedUsername');
    const rememberedPassword = localStorage.getItem('rememberedPassword');
    const wasRemembered = localStorage.getItem('rememberMe') === 'true';
    
    if (wasRemembered && rememberedUsername && rememberedPassword) {
      setUsername(rememberedUsername);
      setPassword(rememberedPassword);
      setRememberMe(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Handle remember me
    if (rememberMe) {
      localStorage.setItem('rememberedUsername', username);
      localStorage.setItem('rememberedPassword', password);
      localStorage.setItem('rememberMe', 'true');
    } else {
      localStorage.removeItem('rememberedUsername');
      localStorage.removeItem('rememberedPassword');
      localStorage.removeItem('rememberMe');
    }

    try {
      const authData = { Username: username, Password: password };
      const userData = { Username: username, Pool: new CognitoUserPool(poolData) };
      const authDetails = new AuthenticationDetails(authData);
      const newCognitoUser = new CognitoUser(userData);
      setCognitoUser(newCognitoUser);

      newCognitoUser.authenticateUser(authDetails, {
        onSuccess: (result) => {
          console.log('Login successful:', result);
          setLoading(false);
          onLoginSuccess(username);
        },
        onFailure: (err) => {
          console.error('Auth Error:', err);
          setError(err.message || 'Login failed');
          setLoading(false);
        },
        newPasswordRequired: (userAttributes, requiredAttributes) => {
          console.log('New password required');
          setShowNewPasswordForm(true);
          setLoading(false);
        }
      });
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleNewPasswordSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    cognitoUser.completeNewPasswordChallenge(newPassword, {}, {
      onSuccess: (result) => {
        console.log('Password change successful:', result);
        setLoading(false);
        setShowNewPasswordForm(false);
        onLoginSuccess(username);
      },
      onFailure: (err) => {
        console.error('Password change error:', err);
        setError(err.message || 'Failed to set new password');
        setLoading(false);
      }
    });
  };

  if (showNewPasswordForm) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center p-4">
        {/* Inject custom animations */}
        <style dangerouslySetInnerHTML={{ __html: animationStyles }} />
        
        <div className="w-full max-w-md">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl blur-2xl"></div>
            <div className="relative bg-gradient-to-br from-slate-900/95 to-slate-800/95 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-8 shadow-2xl">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-bold text-white">Set New Password</h2>
                <p className="mt-2 text-gray-400">Please set a new password for your account</p>
              </div>

              <div className="space-y-5">
                <div>
                  <div className="block text-sm font-medium text-gray-300 mb-2">New Password</div>
                  <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleNewPasswordSubmit(e)}
                    className="w-full px-4 py-3 bg-slate-800/50 border border-slate-700/50 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    placeholder="Enter your new password"
                  />
                </div>

                {error && (
                  <div className="p-3 bg-red-900/30 border border-red-700/50 rounded-lg">
                    <div className="text-sm text-red-300">{error}</div>
                  </div>
                )}

                <button
                  onClick={handleNewPasswordSubmit}
                  disabled={loading}
                  className="w-full py-3 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 rounded-lg text-white font-medium shadow-lg shadow-blue-500/25 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <div className="flex items-center justify-center space-x-2">
                      <div className="w-5 h-5 border-t-2 border-b-2 border-white rounded-full animate-spin"></div>
                      <span>Setting new password...</span>
                    </div>
                  ) : (
                    'Set New Password'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center p-4">
      {/* Inject custom animations */}
      <style dangerouslySetInnerHTML={{ __html: animationStyles }} />
      
      <div className="w-full max-w-md">
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl blur-2xl"></div>
          <div className="relative bg-gradient-to-br from-slate-900/95 to-slate-800/95 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-8 shadow-2xl">
            <div className="text-center mb-8">
              <div className="flex justify-center mb-6">
                <VisionIQLogo size={120} />
              </div>
              <ChangingText />
            </div>

            <div className="space-y-5">
              <div>
                <div className="block text-sm font-medium text-gray-300 mb-2">Licence ID</div>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleLogin(e)}
                  className="w-full px-4 py-3 bg-slate-800/50 border border-slate-700/50 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  placeholder="Enter your Licence ID"
                />
              </div>

              <div>
                <div className="block text-sm font-medium text-gray-300 mb-2">Password</div>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleLogin(e)}
                    className="w-full px-4 py-3 bg-slate-800/50 border border-slate-700/50 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    placeholder="Enter your password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-300 focus:outline-none"
                  >
                    {showPassword ? (
                      <EyeOff className="w-5 h-5" />
                    ) : (
                      <Eye className="w-5 h-5" />
                    )}
                  </button>
                </div>
              </div>

              {error && (
                <div className="p-3 bg-red-900/30 border border-red-700/50 rounded-lg">
                  <div className="text-sm text-red-300">{error}</div>
                </div>
              )}

              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="w-4 h-4 border-gray-600 rounded text-blue-600 focus:ring-blue-500 bg-slate-800"
                  />
                  <div className="ml-2 text-sm text-gray-400">Remember me</div>
                </div>
              </div>

              <button
                onClick={handleLogin}
                disabled={loading}
                className="w-full py-3 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 rounded-lg text-white font-medium shadow-lg shadow-blue-500/25 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? (
                  <div className="flex items-center justify-center space-x-2">
                    <div className="w-5 h-5 border-t-2 border-b-2 border-white rounded-full animate-spin"></div>
                    <span>Signing in...</span>
                  </div>
                ) : (
                  'Sign In'
                )}
              </button>
              
              {/* VisionIQ branding moved to bottom */}
              <div className="text-center pt-4 border-t border-slate-700/50">
                <h3 className="text-lg font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-1">
                  WidthIQ
                </h3>
                <p className="text-xs text-gray-400 font-medium">Made by Nommas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;